module.exports = __webpack_public_path__ + "static/media/just_in_time.d1153d18.svg";